import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import EventClaim from "./components/EventClaim";

function EventClaimPage() {

    return (
        <ToastProvider>
            <Dashboard>
                <EventClaim />
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}

export default EventClaimPage